module.exports = __webpack_public_path__ + "img/progress-en.7df3ca2b.webp";